import { useQuery } from "@tanstack/react-query";
import { AppointmentControllerApi } from "../services";
import { getConfigObject, useBaseData } from "../utils/utils";

interface FutureProps {
  providerId: string;
  xTENANTID?: string;
  disabled: boolean;
}

export function useGetFutureAppointment({
  providerId,
  xTENANTID,
  disabled,
}: FutureProps): useBaseData<any> {
  const refetch = () => {};
  // // todo: AS per B.E removing this api response
  return { data: { data: null }, refetch: refetch as any } as any;

  return useQuery({
    queryKey: ["future-appointment", providerId, xTENANTID],
    enabled: !!providerId && !disabled,
    // placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    // retry: (failCount) => failCount < 2,
    queryFn: async () =>
      new AppointmentControllerApi(getConfigObject())
        .futureAppointment(providerId, xTENANTID)
        .then((it) => it?.data),
  });
}
